// Histórico de versões do sistema. Adicionar um novo item no TOPO da lista
// (mais recente primeiro) sempre que uma entrega for concluída.

export interface VersaoHistorico {
  versao: string;
  titulo?: string;
  itens: string[];
}

export const historicoVersoes: VersaoHistorico[] = [
  {
    versao: "07/10/2026",
    titulo: "Cobrança",
    itens: [
      "Tela de Cobrança: novo botão de lupa na coluna Opções, que abre uma janela com todos os dados do boleto e a lista de remessas e retornos em que ele aparece",
      "Cadastro do cliente > Contratos/Planos > Ver Parcelas: botão para imprimir o boleto em toda parcela que possui boleto (inclusive as já pagas)",
      "Tela de Cobrança: botões 'Atualizar busca' e 'Limpar filtros' agora ficam na mesma linha dos demais filtros e o rodapé foi reorganizado (botões de ação em uma linha; totais e paginação em outra), sem sobreposição",
    ]
  },
  {
    versao: "02/10/2026",
    titulo: "Boletos e Contratos",
    itens: [
      "Tela de Boletos: opção 'Cancelar' no menu de ações agora funciona, mudando o status do boleto para Cancelado — disponível somente para boletos com status 'Enviar'",
      "Tela de Boletos: coluna Banco oculta por padrão, nova coluna 'Dt Documento' antes do vencimento e novos filtros 'Dt Docto Ini' e 'Dt Docto Fin'",
      "Cadastro do cliente > Contratos/Planos: novo botão 'Cancelar contrato' (supervisor/admin), com motivo. As parcelas em aberto são canceladas, boletos com status 'Enviar' são cancelados e parcelas pagas ou com boleto já enviado/registrado no banco são mantidas",
      "Contrato cancelado não gera mais boletos nem novas parcelas (inclusive pela rotina automática), e as parcelas canceladas deixam de aparecer em Contas a Receber, relatórios, dashboard e painéis do cliente/empresa",
    ]
  },
  {
    versao: "01/10/2026",
    titulo: "Parcelas e Parâmetros",
    itens: [
      "Parâmetros do sistema: novo campo 'Dia Vencimento Boleto' (padrão dia 10), usado como vencimento padrão de novos boletos quando nenhum outro dia for definido",
      "Cadastro do cliente > Contratos/Planos > Ver Parcelas: novo botão 'Gerar Parcelas', que calcula 12 parcelas mensais a partir de uma data inicial (pré-preenchida com o dia do parâmetro) antes de gravar, permitindo conferir e ajustar os vencimentos",
    ]
  },
  {
    versao: "19/09/2026",
    titulo: "Dashboard",
    itens: [
      "Nova tela inicial do painel administrativo com dashboard: recebido, a receber e atrasado no mês, contratos ativos, clientes ativos e novos clientes no mês",
      "Gráficos de previsto x recebido, situação das parcelas do mês, novos clientes por mês e top 5 cidades por valor recebido",
    ]
  },
  {
    versao: "18/09/2026",
    titulo: "Contratos, Boletos, Logs e Relatórios",
    itens: [
      "Painel do cliente: mensalidade sem boleto gerado não aparece mais como vencida",
      "Contratos: novo botão na listagem para estender a validade de um contrato específico, sem precisar rodar a rotina em lote",
      "Boletos: removida a instrução automática de protesto e negativação enviada ao banco",
      "Logs do sistema: adicionadas as colunas Cliente e Empresa, filtro de pesquisa por texto (Local/Descrição) e filtro por Cliente (autocomplete)",
      "Relatório de Clientes: nova opção 'Gerar Excel' (.xlsx), com a coluna CPF sempre em formato texto para preservar os zeros à esquerda",
      "Nova rotina de backup automático diário do banco de dados e dos arquivos do sistema, com envio por e-mail/FTP/Google Drive",
      "Corrigido erro ao abrir a janela de confirmação de exclusão em Dependentes, Contratos e Vouchers no cadastro do cliente",
      "Corrigido filtro Empresa (e outros filtros semelhantes) que não limpava a pesquisa ao selecionar novamente '- Selecione -'",
    ]
  },
  {
    versao: "30/08/2026",
    titulo: "Cartões",
    itens: [
      "Ajuste na impressão do cartão para que o nome ajuste em duas linhas"
      ]
  },
  {
    versao: "27/08/2026",
    titulo: "Relatórios",
    itens: [
      "Relatorio de clientes foi adicionado o filtro Empresa"
      ]
  },
  {
    versao: "23/08/2026",
    titulo: "Relatórios",
    itens: [
      "Melhoria no relatório de clientes - Seguros",
      "Clientes: Nas mensalidades do cliente foi adicionado o botao Pagar para pagar a mensalidade do cliente diretamente no painel administrativo, sem precisar ir para a tela de cobrança",
      "Contas a receber: foi adicionado o botao Pagar para pagar a mensalidade do cliente"
      ]
  },
  {
    versao: "22/08/2026",
    titulo: "Relatórios",
    itens: [
      "Melhoria no relatório de clientes - Assistência Funeral: agora mostra apenas os clientes com CPF, e no final uma lista dos dependentes sem CPF",
      "Dependentes: Corrigido erro ao excluir dependente e ao fechar a janela tambem",
    ]
  },
  {
    versao: "15/08/2026",
    titulo: "Cobrança e Contratos",
    itens: [
      "Nova tela em Cobrança para importar a planilha de Títulos do banco (Vencidos, Liquidados ou Baixados): o tipo é detectado automaticamente e uma tela de conferência mostra a ação proposta para cada boleto (marcar como pago, baixar), permitindo marcar/desmarcar antes de aplicar",
      "Tela de Histórico de Versões criada, liberada para qualquer usuário logado",
      "Planos > Cadastro > aba Contrato: novo botão para aplicar o texto atual do Plano aos contratos já vinculados, inclusive os já assinados — a assinatura do cliente e da contratada são preservadas e reaplicadas ao novo texto",
    ]
  },
  {
    versao: "13/08/2026",
    titulo: "Contratos e parcelas",
    itens: [
      "Cadastro do cliente: botão 'Ver parcelas' agora abre um modal com as parcelas do contrato, em vez de ir para a tela de Contas a Receber",
      "Modal de parcelas permite alterar vencimento e valor apenas de parcelas sem boleto gerado e sem pagamento",
      "Botão para abrir o boleto direto da parcela quando ele existe e ainda não foi pago",
      "Exclusão de contrato liberada quando ainda não foi assinado (antes bloqueava qualquer exclusão)",
      "Mensagens de erro reais do servidor passaram a aparecer nas telas (antes mostrava só o erro genérico de conexão)",
    ]
  },
  {
    versao: "07/08/2026",
    titulo: "Relatórios, logs e assinatura de contrato",
    itens: [
      "Logs do sistema: tela passou a consultar o banco de dados com filtros de usuário, data início e data fim (antes só listava arquivos em disco)",
      "Relatórios: cabeçalhos de coluna clicáveis para ordenar; exportação trocada de Excel para CSV real",
      "Cadastro de Planos reorganizado em abas: Cadastro, Adicionais e Contrato",
      "Corrigida a imagem da assinatura da Contratada que não aparecia no texto dos contratos",
      "Área de assinatura do contrato aumentada e responsiva, no painel administrativo e no painel do cliente",
      "Corrigido o erro de conexão ao clicar em Sair no painel do cliente",
      "Link de acesso externo do cliente (gerado pelo admin) liberado mesmo com o cliente inativo",
      "Tabelas de listagem voltaram a ser responsivas por scroll horizontal, sem virar cards no celular",
    ]
  },
];
